/**
 * format a javascript object into query string, keep the key value in alphabetic order
 * @static
 * @param {object} json
 * @returns {string} query string
 */
export function jsonToQueryString(
  json: Record<
  string,
  string | null | undefined | number | boolean | Array<any>
  >,
  skipQuestionMark = false,
): string {
  if (!json) {
    return '';
  }
  const keys = Object.keys(json).filter(key => {
    const val = json[key];
    return typeof val !== 'undefined' && val !== null;
  });
  if (!keys.length) {
    return '';
  }
  return (
    (skipQuestionMark ? '' : '?')
    + keys
      .sort()
      .map(key => `${encodeURIComponent(key)}=${
        // undefined | null is already filtered out above
        encodeURIComponent(json[key] as string | number | boolean)
      }`)
      .join('&')
  );
}
